// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__6_6gr","footerContainer":"styles_footerContainer__6NC_Q"};